(function (global) {
    define('MM/Components/Forms/PrivacyPolicyForm',[
        "eventManager",
        "jquery",
        "underscore",
        "MM/Components/Forms/ValidationOptions",
        "underscoreTemplates",
        "formsBase",
        "phoneScript",
        "phoneUtil",
        "MM/Components/Forms/RecaptchaApiLoader",
        "jqueryValidate",
        "jqueryValidateUnobtrusive",
        "jqueryUnobtrusiveAjax",
        "mmUnobtrusiveExtensions"
    ], function (eventManager, $, _, vo, ut, fb, phoneScript, phoneUtil) {
        function PrivacyPolicyForm(args) {
            if (args.IsPageEditorEditing) {
                return;
            }

            var $btnSubmit = $(".btnSubmit", args.scope);
            var $form = $("#" + args.FormId, args.scope);
            var $formResult = $(".formResult", args.scope);
            var formResultTemplate = $("#formResultTemplate-" + args.FormId, args.scope).html();
            var formErrResultTemplate = $("#formErrResultTemplate-" + args.FormId, args.scope).html();
            var formErrResultLineTemplate = $("#formErrResultLineTemplate-" + args.FormId, args.scope).html();
            var loadingText = args.LoadingText;
            var defaultErrorText = args.ErrorText;
            var successText = args.SuccessText;
            var successTitle = args.SuccessTitle;

            var isEnableReCaptcha = !0;
            var rApiLoaded = 'RecaptchaApiLoaded';
            var recaptchaType = 'invisible';
            var recaptchaPlaceholder = args.scope.querySelector('.g-recaptcha');
            var $recaptchaInput = $('#ReCaptcha', args.scope);
            var recaptchaWidgetId = '';
            var isInvisibleRecaptchaType = recaptchaType === "invisible" && isEnableReCaptcha;

            var lblArr = args.scope.querySelectorAll('.row .form-group label:not(:has(input))');
            if (lblArr && lblArr.length) {
                [].slice.call(lblArr).forEach(function (lblEl) {
                    lblEl.innerHTML = lblEl.innerText.replace(/[*]/ig, '<span>$&</span>')
                });
            }

            $(args.scope).removeAttr("data-ux-module");
            $form.removeData("validator").removeData("unobtrusiveValidation");
            $.validator.setDefaults(vo.getDefaultOptions());
            $.validator.unobtrusive.options = vo.getUnobtrusiveOptions();
            $.validator.unobtrusive.parse($form);

            // Set the change event for checkboxes
            $form.find(".form-group .checkbox input[type=checkbox]").change(function (e) {
                var selectedCheckbox = e.currentTarget;
                var $hiddenField = $("#" + selectedCheckbox.dataset.chkFor, $form);
                if ($hiddenField.length > 0) {
                    $hiddenField.val(selectedCheckbox.checked ? "1" : "");
                    $hiddenField.valid();
                } else {
                    console.log("Parameter 'data-chk-for' is not configured some of checkboxes inside the form");
                }
            });

            var settngs = $.data($form[0], 'validator').settings;
            settngs.ignore = "#PhoneIti" + args.FormId;

            PhoneScriptCallback()

            $form.submit(function (e) {
                if ($btnSubmit.hasClass("disabled")) {
                    return false;
                }
                if ($form.valid()) {
                    if (isInvisibleRecaptchaType) {
                        if (recaptchaWidgetId !== "") {
                            grecaptcha.reset(recaptchaWidgetId);
                            grecaptcha.execute(recaptchaWidgetId);
                        }
                    } else {
                        submitForm();
                    }
                }
                return false;
            });

            $form.on("click", function (event) {
                if ($(this).hasClass("disabled") || $btnSubmit.hasClass("disabled")) {
                    event.stopPropagation();
                } else {
                    if ($formResult.is(":visible") && $formResult.html().trim() !== "") {
                        $formResult.fadeOut().empty();
                    }
                }
            });
            $form.find('input, textarea').each(function (index, el) {
                el.addEventListener('change', trackFieldsSelection);
            });


            eventManager.subscribe(rApiLoaded, renderRecaptcha.bind(this));

            function submitForm() {
                $formResult.fadeOut().empty();
                var defaultText = $btnSubmit.text();
                $btnSubmit.text(loadingText).addClass("disabled");
                var submitData = $form.serialize();
                submitData = submitData.replace("g-recaptcha-response", 'Recaptcha');

                $.ajax({
                    url: $form.get(0).action,
                    type: $form.get(0).method,
                    data: submitData,
                    dataType: "json",
                    traditional: true,
                    success: function (result) {
                        ut.renderTemplate($formResult, formResultTemplate, { item: successText, header: successTitle  });
                        refreshAfterSubmit(recaptchaWidgetId, defaultText, true);
                        // triggers event for GA dataLayer creation 
                        eventManager.trigger("team_contact_us_form:submitted", submitData + "&formName=" + $form.get(0).name);
                    },
                    error: function (xhr) {
                        var result = {};
                        try {
                            result = fb.getAjaxErrorResult(xhr);
                        }
                        catch (e) {
                            result[0] = defaultErrorText;
                        }
                        finally {
                            if (result.length && result.length > 1) {
                                ut.renderTemplate($formResult, formErrResultTemplate, { items: result });
                            } else if (result.length && result.length === 1) {
                                ut.renderTemplate($formResult, formErrResultLineTemplate, { item: result[0] });
                            } else {
                                ut.renderTemplate($formResult, formErrResultLineTemplate, { item: defaultErrorText });
                            }
                            refreshAfterSubmit(recaptchaWidgetId, defaultText, false);
                        }
                    }
                });
            }

            function refreshAfterSubmit(recaptchaWidgetId, defaultText, isSuccess) {
                $btnSubmit.text(defaultText).removeClass("disabled");
                if ($recaptchaInput.length > 0) {
                    $recaptchaInput.val("");
                }
                if (isSuccess) {
                    $form.closest('div.ipa-contact-form').prevAll('*:not(script)').each(function (i, el) { jQuery(el).fadeOut() })
                    $('.mm-content-search-back-to-search').each(function (i, el) { $(el).fadeOut() });
                    $form.fadeOut();
                    $formResult.fadeIn(2000, function (e) {
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                    });
                } else {
                    $formResult.fadeIn().delay(3000).fadeOut(2000);
                }
            }

            function resetForm() {
                $form.validate().resetForm();
                $form.get(0).reset();
                $form.find(".has-success, .has-error").removeClass("has-success").removeClass("has-error");
                $form.find(".field-validation-valid").empty();
                $form.find("input.valid, textarea.valid").removeClass('valid');
                $form.find("input[type=radio]").attr("checked", false);
            }


            function renderRecaptcha() {
                if (!recaptchaPlaceholder) { return; }
                if (grecaptcha == void 0) { return; }
                recaptchaWidgetId = grecaptcha.render(recaptchaPlaceholder, {
                    'sitekey': recaptchaPlaceholder.dataset.sitekey,
                    'size': recaptchaType,
                    'callback': function (response) {
                        if (isInvisibleRecaptchaType) {
                            submitForm();
                        } else {
                            $recaptchaInput.val(response).valid();
                        }
                    },
                    'expired-callback': function () {
                        if (recaptchaWidgetId !== "") {
                            grecaptcha.reset(recaptchaWidgetId);
                        }
                        if (!isInvisibleRecaptchaType) {
                            $recaptchaInput.val("").valid();
                        }
                    },
                    badge: "inline"
                });
            }

            function trackFieldsSelection() {
                var $elements = $form.find('input[type]:not([type=\'hidden\']), textarea');
                $elements.each(function (index, el) {
                    ((!!el.value)
                        ? el.classList.add('selection-complete')
                        : el.classList.remove('selection-complete'));
                });
            }

            function PhoneScriptCallback() {
                var phoneCss = document.createElement('link');
                phoneCss.rel = 'stylesheet';
                phoneCss.type = 'text/css';
                phoneCss.href = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/css/intlTelInput.css';
                document.head.appendChild(phoneCss);

                var userPhoneIti = document.querySelector("#PhoneIti" + args.FormId);
                var userPhoneNumberField = document.querySelector("#Phone" + args.FormId);
                var userPhoneCountryCodeField = document.querySelector("#PhoneCountryCode" + args.FormId);

                var groupSelector = userPhoneIti.parentElement.closest('div.form-group');
                var spanMsg = groupSelector.querySelector('span[data-valmsg-for="Phone"]');
                var errorMsgDefault = userPhoneNumberField.getAttribute('data-val-required');
                var errorMsgFormat = userPhoneNumberField.getAttribute('data-val-regex');

                var iti = window.intlTelInput(userPhoneIti, {
                    utilsScript: phoneUtil,
                    preferredCountries: ["us", "ca"],//Optional preffered countries can be pinned on top of the list
                    separateDialCode: true,//Optional shows country code next to the country flag                
                    formatOnDisplay: "true",//Format the input value during initialisation                
                    autoPlaceholder: "aggressive",//Optional shows masked number placeholder instead of b2c's default placeholder
                    customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                        return selectedCountryPlaceholder.replace(/\d/g, "5");
                    }
                });

                // a generic way to call trackFieldsSelection() function
                userPhoneIti.dispatchEvent(new Event('change'));

                userPhoneIti.addEventListener('keyup', onPhoneNumberChanged);
                userPhoneIti.addEventListener('change', onPhoneNumberChanged);
                userPhoneIti.addEventListener('countrychange', onCountryChanged);

                //CSS added to properly show dropdown. This should be added using styles not javascript
                userPhoneIti.style.cssText += 'padding-left:80px;';
                var phoneContainer = document.getElementsByClassName("iti iti--allow-dropdown")[0];
                phoneContainer.style.cssText += 'width:100%;margin-bottom: 0 !important;';

                function onCountryChanged() {
                    userPhoneIti.dispatchEvent(new Event('change'));
                }

                function onPhoneNumberChanged() {
                    if (userPhoneIti.value.trim()) {
                        if (iti.isValidNumber()) {
                            var countryCode = '+' + iti.getSelectedCountryData().dialCode;
                            var phoneNumber = iti.getNumber().replace(countryCode, "");
                            userPhoneCountryCodeField.value = countryCode;
                            userPhoneNumberField.value = phoneNumber;

                            groupSelector.classList.remove('has-error');
                            groupSelector.classList.add('has-success');

                            spanMsg.classList.remove('field-validation-error');
                            spanMsg.classList.add('field-validation-valied');
                            spanMsg.innerHTML = '';
                        }
                        else {
                            userPhoneCountryCodeField.value = '';
                            userPhoneNumberField.value = '';

                            groupSelector.classList.remove('has-success');
                            groupSelector.classList.add('has-error');

                            var errorMsg = errorMsgFormat || errorMsgDefault;
                            spanMsg.classList.remove('field-validation-valid');
                            spanMsg.classList.add('field-validation-error');
                            spanMsg.innerHTML = '<span class="text-danger">' + errorMsg + '</span>';
                        }
                    }
                    else {
                        groupSelector.classList.remove('has-error');
                        groupSelector.classList.remove('has-success');

                        spanMsg.classList.remove('field-validation-error');
                        spanMsg.classList.add('field-validation-valied');
                        spanMsg.innerHTML = '';

                        userPhoneCountryCodeField.value = '';
                        userPhoneNumberField.value = '';

                    }
                }
            };
        }

        return function init(args) {
            return new PrivacyPolicyForm(args);
        };
    });
})(this);
